"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _bottomWrapper;

  return {
    root: {
      position: "relative"
    },
    swiperRoot: _defineProperty({
      background: theme.palette.grey[300],
      position: "relative"
    }, theme.breakpoints.up("md"), {
      background: "none"
    }),
    swiper: {
      "& .swiper-slide": {
        height: "auto",
        userSelect: "none"
      }
    },
    bottomWrapper: (_bottomWrapper = {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      padding: theme.spacing(0, 2, 2)
    }, _defineProperty(_bottomWrapper, theme.breakpoints.up("md"), {
      bottom: 80,
      padding: theme.spacing(0, 4, 2),
      position: "absolute",
      right: 0,
      width: "50%",
      zIndex: 1
    }), _defineProperty(_bottomWrapper, theme.breakpoints.up("lg"), {
      bottom: 100,
      padding: theme.spacing(0, 7, 5),
      width: "40%"
    }), _bottomWrapper),
    swiperNavigation: {
      display: "flex",
      gap: theme.spacing(1),
      "& .swiper-button-prev, .swiper-button-next": {
        cursor: "pointer"
      },
      "& .swiper-button-disabled": {
        opacity: 0.5,
        pointerEvents: "none"
      }
    },
    swiperNav: {
      cursor: "pointer",
      userSelect: "none"
    },
    swiperPagination: {
      bottom: "auto",
      display: "flex",
      gap: theme.spacing(1),
      position: "relative",
      userSelect: "none"
    }
  };
});
var _default = styles;
exports.default = _default;